import { Container } from 'pixi.js';

import { config } from '../config/config';
import { clamp } from '../helpers/tools';
import { Coordinates } from './declarations/PositionInfo';

export default class BulletLayer extends Container {
  private size: Coordinates;

  constructor(name: string, size: Coordinates) {
    super();

    this.name = `BulletLayer_${name}`;
    this.size = size;
  }

  //ratio -0.5 - 0.5
  setPosition(ratio: Coordinates) {
    const pos = this.ratioToPosition(ratio);
    this.x = pos.x;
    this.y = pos.y;
  }

  ratioToPosition(ratio: Coordinates) {
    return {
      x: -(this.size.x - config.SIZES.MAX_WIDTH) * ratio.x,
      y: -(this.size.y - config.SIZES.MAX_HEIGHT) * ratio.y,
    };
  }

  positionToRatio(position: Coordinates) {
    return {
      x:
        this.size.x - config.SIZES.MAX_WIDTH === 0
          ? 0
          : clamp(-position.x / (this.size.x - config.SIZES.MAX_WIDTH), -0.5, 0.5),
      y:
        this.size.y - config.SIZES.MAX_HEIGHT === 0
          ? 0
          : clamp(-position.y / (this.size.y - config.SIZES.MAX_HEIGHT), -0.5, 0.5),
    };
  }

  //layerPoint (0-config.SIZES.SCENE_WIDTH, 0 - config.SIZES.SCENE_HEIGHT)
  getStageRatio(layerPoint: Coordinates) {
    const fromCenterPosition = {
      x: config.SIZES.SCENE_WIDTH / 2 - layerPoint.x,
      y: config.SIZES.SCENE_HEIGHT / 2 - layerPoint.y,
    };
    return this.positionToRatio(fromCenterPosition);
  }
}
